import store from '../store/index'
//-----------------------------
// calc container availability
//-----------------------------
export default function calcContainerAvailability({ container_id, character }) {
  console.log('-----------------------------')
  console.log('IN calcContainerAvailability with container_id = ', container_id)
  /*
  =================================================================
  GETTING CAPACITY (use cases):

  Use Case 1: Regular container ..... xxxxxx
  -----------------------------------------------------------------


  Use Case 2: Artefact container
  -----------------------------------------------------------------
  character_item ('character_container') 
          -> character_item.item ('artefact_container_item') 
                  -> item.artefact_base_item ('artefact_base_item')
                          -> artefact_base_item.container_size 
                                  -> container_size.capacity
  =================================================================
  */
  // --------------------------
  // defs
  // --------------------------
  let capacity_container = null
  let capacity = null
  // =====================================================================================
  // A. find character container item
  // ---------------------------------

  // trap missing container_id or character
  if (!container_id || !character) {
    console.error('*** calcContainerAvailability - missing character container_id or character')
    return null
  }

  // find character container item
  const character_container = character.items.find((c) => c.id === container_id) || null

  // error if character container not found
  if (!character_container) {
    console.error(
      '*** calcContainerAvailability - character container not found for id:',
      container_id,
    )
    return null
    // else character container found
  } else {
    console.log('calcContainerAvailability found character container = ', character_container)
  }
  // =====================================================================================
  // B. artefact container
  // ----------------------
  if (
    character_container.type === 'Artefact' &&
    character_container.artefact_type === 'Container'
  ) {
    const artefactBaseItemId = character_container.artefact_base_item ?? null

    if (artefactBaseItemId) {
      capacity_container =
        store.getters['characters/getContainerSizeByBaseItemId'](artefactBaseItemId)

      if (capacity_container) {
        console.log(
          '*** calcContainerAvailability - local artefact capacity container = ',
          capacity_container,
        )
        capacity = capacity_container.capacity
      } else {
        console.error(
          '*** calcContainerAvailability - local artefact capacity container not found for artefact base item id:',
          artefactBaseItemId,
        )
        return null
      }
    } else {
      // error if artefact container item not found
      if (!character_container.item) {
        console.error(
          '*** calcContainerAvailability - 1. ERROR artefact container item not found for id:',
          container_id,
        )
        return null
      }

      // get artefact container item
      const artefact_container_item = store.getters['characters/getStaticItemById'](
        character_container.item,
      )

      // found artefact container item
      if (artefact_container_item) {
        console.log(
          '*** calcContainerAvailability - 2. SUCCESS found artefact container = ',
          artefact_container_item,
        )

        // error if artefact base item not found
        if (artefact_container_item.artefact_base_item) {
          console.log(
            '*** calcContainerAvailability - 4. SUCCESS got artefact base item id = ',
            artefact_container_item.artefact_base_item,
          )

          // get base 'capacity' container item
          capacity_container = store.getters['characters/getContainerSizeByBaseItemId'](
            artefact_container_item.artefact_base_item,
          )

          // found capacity container
          if (capacity_container) {
            console.log(
              '*** calcContainerAvailability - 5. SUCCESS found capacity container = ',
              capacity_container,
            )

            // set capacity
            capacity = capacity_container.capacity

            // error if capacity container not found
          } else {
            console.error(
              '*** calcContainerAvailability - 6. ERROR capacity container not found for artefact base item id:',
              artefact_container_item.artefact_base_item,
            )
            return null
          }

          // error if artefact base item not found
        } else {
          console.error(
            '*** calcContainerAvailability - 7. ERROR artefact base item not found for id:',
            container_id,
          )
          return null
        }

        // error if artefact base item not found
      } else {
        console.error(
          '*** calcContainerAvailability - 8. ERROR artefact container item not found for id:',
          container_id,
        )
        return null
      }
    }

    // =====================================================================================
    // B. regular container
    // ---------------------
  } else {
    // set capacity container
    capacity_container = character_container

    // set capacity
    capacity = capacity_container.container_size.capacity
  }
  // =====================================================================================
  // C. check for container_size & capacity
  // ---------------------------------------
  if (!capacity_container || !capacity || typeof capacity !== 'number') {
    console.error(
      '*** calcContainerAvailability - 9. ERROR capacity container not found or invalid capacity for id:',
      container_id,
    )
    return null
  }
  // =====================================================================================
  // D. return container details
  // ----------------------------
  console.log('calcContainerAvailability capacity container = ', capacity_container)

  console.log(
    'container capacity = ',
    capacity,
    ' contents_count_direct= ',
    character_container.contents_count_direct,
    ' contents_enc = ',
    character_container.contents_enc,
  )

  // calculate available capacity (rounded to 2 decimals to avoid
  // floating point tails like 0.12999999999999998)
  const rawAvailable = capacity - character_container.contents_enc
  const available_capacity = Math.round((rawAvailable + Number.EPSILON) * 100) / 100

  console.log('available_capacity = ', available_capacity)

  return {
    name: character_container.name,
    capacity: capacity,
    availability: available_capacity,
    contents_enc: character_container.contents_enc,
    contents_count_direct: character_container.contents_count_direct,
  }
}
